import { FC } from "react";

import { IconProps } from "./IconProps";

export const Share: FC<IconProps> = ({
  className,
  size = 16,
  color = "currentColor",
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M18 8C19.6569 8 21 6.65685 21 5C21 3.34315 19.6569 2 18 2C16.3431 2 15 3.34315 15 5C15 5.12548 15.0077 5.24917 15.0227 5.37061L8.08259 9.19183C7.54305 8.46837 6.71932 8 5.78571 8C4.24107 8 3 9.34315 3 11C3 12.6569 4.24107 14 5.78571 14C6.71932 14 7.54305 13.5316 8.08259 12.8082L15.0227 16.6294C15.0077 16.7508 15 16.8745 15 17C15 18.6569 16.3431 20 18 20C19.6569 20 21 18.6569 21 17C21 15.3431 19.6569 14 18 14C17.0664 14 16.2426 14.4684 15.7031 15.1918L8.76294 11.3706C8.77795 11.2492 8.78571 11.1255 8.78571 11C8.78571 10.8745 8.77795 10.7508 8.76294 10.6294L15.7031 6.80817C16.2426 7.53163 17.0664 8 18 8Z"
      fill={color}
    />
  </svg>
);
